import { render, staticRenderFns } from "./SideMenuItemGroup.vue?vue&type=template&id=2aea626c"
import script from "./SideMenuItemGroup.vue?vue&type=script&lang=js"
export * from "./SideMenuItemGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports